import React from "react";
import Sanitize from "./sanitize";

export default function ParagraphShortening({ text, howMuch = 30 }) {
  let string =
    text.length > howMuch ? text.substring(0, howMuch) + "..." : text;

  return <Sanitize html={string} />;
}
